module.exports = __webpack_public_path__ + "static/media/IMG_0007.6116842f.jpg";